<div class="content-box"  [ngClass]="{'hidden-box': type=='blank', 'disabled-box': disabled, 'yellow-status': statusColor == 'yellow', 'orange-status': statusColor == 'orange' , 'red-status': statusColor == 'red', 'green-status': statusColor == 'green', 'popup-field': type == 'popup', 'full-width':fullWidth}">
  <label>{{ title | translate }}</label>
  <div class="content-box-input">

    @if (!disabled && type != 'popup') {
      <div  class="content-box-field">
        @if (type=='select') {
          <select [attr.disabled]="disabled ? disabled : null" name="input-value"  (change)="changeValue($event)">
            <option>{{ 'Select' | translate }}</option>
            @for (option of selectList; track option) {
              <option [value]="option.id" [selected]="value==option.id">{{ option.name | translate }}</option>
            }
          </select>
        } @else {
          <input [attr.disabled]="disabled ? disabled : null" type="number" name="input-value" [value]="value" (change)="changeValue($event)">
          @if (type == 'percent') {
            <span  class="content-box-input-sufix">%</span>
          }
        }
      </div>
    }


    @if (disabled || type == 'popup') {
      <div class="content-box-label" (click)="type == 'popup' && openPopUp()">
        @if (type == 'number' || type == 'percent' || type == 'popup') {
          <div>
            <div class="number" >
              <ng-container >
                <span>{{(getRoofValue(value)) | number:'1.0-0'}}</span>
                @if (get1000Value(value); as decimals) {
                  <span class="percent">.
                    {{ decimals }}
                  </span>
                }
                @if (type == 'percent') {
                  <span  class="percent">%</span>
                }
              </ng-container>
            </div>
          </div>
        }
        @if (type == 'minutes') {
          <div>
            <div class="number" >
              <span>{{validValue}}</span>
              <span   class="percent">{{getSegValue(value)}}</span>
            </div>
          </div>
        }
        @if (type == 'pages') {
          <div>
            <div class="number" >
              <span >{{validValue}} </span>
              @if (validValue > 0) {
                <span class="percent">{{getPagesFraction(value)}}</span>
              }
            </div>
          </div>
        }
      </div>
    }

    <div class="content-box-total">
      {{ total | number: '1.0-2'}}
    </div>

  </div>
</div>
